var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14417_9346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.875 22H4.125C1.84663 22 0 20.1534 0 17.875V4.125C0 1.84663 1.84663 0 4.125 0H17.875C20.1534 0 22 1.84663 22 4.125V17.875C22 20.1534 20.1534 22 17.875 22Z",
    fill: "#CF0A2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7.69141L16.9881 5.54787C16.9833 4.69177 16.201 4 15.2377 4H6.38462C5.61991 4 5 4.55089 5 5.23047V16.7695C5 17.4491 5.61991 18 6.38462 18H15.6154C16.3801 18 17 17.4491 17 16.7695V7.69141ZM13.7692 9.03429H8.23077C7.97566 9.03429 7.76923 8.85084 7.76923 8.62413C7.76923 8.39743 7.97566 8.21398 8.23077 8.21398H13.7692C14.0243 8.21398 14.2308 8.39743 14.2308 8.62413C14.2308 8.85084 14.0243 9.03429 13.7692 9.03429ZM8.23077 10.6749H13.7692C14.0243 10.6749 14.2308 10.4915 14.2308 10.2648C14.2308 10.0381 14.0243 9.8546 13.7692 9.8546H8.23077C7.97566 9.8546 7.76923 10.0381 7.76923 10.2648C7.76923 10.4915 7.97566 10.6749 8.23077 10.6749ZM13.7692 12.3155H8.23077C7.97566 12.3155 7.76923 12.1321 7.76923 11.9054C7.76923 11.6787 7.97566 11.4952 8.23077 11.4952H13.7692C14.0243 11.4952 14.2308 11.6787 14.2308 11.9054C14.2308 12.1321 14.0243 12.3155 13.7692 12.3155ZM8.23077 13.9562H11.9231C12.1782 13.9562 12.3846 13.7727 12.3846 13.546C12.3846 13.3193 12.1782 13.1359 11.9231 13.1359H8.23077C7.97566 13.1359 7.76923 13.3193 7.76923 13.546C7.76923 13.7727 7.97566 13.9562 8.23077 13.9562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14417_9346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsGridIcon);
export default __webpack_public_path__ + "static/media/documentsGridIcon.487fa4b36b5de2358a85f277d608cc90.svg";
export { ForwardRef as ReactComponent };